import { IntegrationResponseStatus, IntegrationStatus } from '../../common/types';
import { html, TemplateResult } from 'lit';
import { IntegrationType } from '../../types/integration-type';

export function typeRenderer({ item: { type } }: { item: { type: IntegrationType } }): string {
  return this.stringsTranslator.getTranslatedIntegrationNameByType(type);
}

const statusesToBullets = {
  [IntegrationStatus.ACTIVE]: 'bullet-success',
  [IntegrationStatus.ACTION_NEEDED]: 'bullet-danger',
  [IntegrationStatus.DISABLED]: 'bullet-warning',
  [IntegrationStatus.NOT_LICENSED]: 'bullet-danger',
  [IntegrationStatus.ACTION_NEEDED_YELLOW]: 'bullet-warning',
};

const responseStatusesToBullets = {
  [IntegrationResponseStatus.ACTIVE]: 'bullet-success',
  [IntegrationResponseStatus.UNKNOWN]: 'bullet-neutral',
  [IntegrationResponseStatus.NOT_AVAILABLE]: 'bullet-error',
  [IntegrationResponseStatus.DISABLED]: 'bullet-warning',
};

const unknownStatusBullet = 'bullet-neutral';

export function statusRenderer(item): TemplateResult {
  let overallStatus = item.item.status;
  if (item.item.type === IntegrationType.NSVA) {
    let vulnerabilityScannerStatus = item.item.vulnerabilityScannerStatus ?? IntegrationStatus.DISABLED;
    const networkSensorStatus = item.item.sensors?.[0]?.networkSensorStatus ?? item.item.status;

    const vulnerabilityScanner = item.item.sensors?.[0]?.specifics?.vulnerabilityScanner;
    if (vulnerabilityScanner && vulnerabilityScanner.enabled === true) {
      if (vulnerabilityScanner.isFunctioning === true) {
        vulnerabilityScannerStatus = IntegrationStatus.ACTIVE;
      } else {
        vulnerabilityScannerStatus = IntegrationStatus.ACTION_NEEDED;
      }
    }
    if (overallStatus === IntegrationStatus.ACTION_NEEDED) {
      if (vulnerabilityScannerStatus === IntegrationStatus.ACTIVE || networkSensorStatus === IntegrationStatus.ACTIVE) {
        overallStatus = IntegrationStatus.ACTION_NEEDED_YELLOW;
      }
    }
  }

  const bullet =
      statusesToBullets[overallStatus] !== 'undefined' ? statusesToBullets[overallStatus] : unknownStatusBullet,
    label =
      typeof this.translations.integrationStatusLabels[overallStatus] !== 'undefined'
        ? this.translations.integrationStatusLabels[overallStatus]
        : this.translations.unknownStatusLabel;

  return html`<span class="cell-label has-bullet ${bullet}">${label}</span>`;
}

export function responseStatusRenderer({ item: { responseStatus } }: { item: { responseStatus: IntegrationResponseStatus } }): TemplateResult {
  const bullet = typeof responseStatusesToBullets[responseStatus] !== 'undefined' ? responseStatusesToBullets[responseStatus] : unknownStatusBullet,
    label =
      typeof this.translations.integrationResponseStatusLabels[responseStatus] !== 'undefined'
      ? this.translations.integrationResponseStatusLabels[responseStatus]
      : this.translations.unknownStatusLabel;
  if (responseStatus === IntegrationResponseStatus.UNKNOWN) {
    return label;
  }
  return html`<span class="cell-label has-bullet ${bullet}">${label}</span>`;
}
